import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=642e2e74&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=ts&"
export * from "./Widget.vue?vue&type=script&lang=ts&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=642e2e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e2e74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VMenu})
